import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Select } from "antd";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { SelectPicker } from "rsuite";
import { RiRepeat2Line } from "react-icons/ri";
import { FaChevronDown } from "react-icons/fa";
import { DatePicker, RadioGroup, Radio } from "rsuite";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import Divider from "@mui/material/Divider";
import { InputGroup, Input } from "rsuite";
import { useFormik } from "formik";
import { useAddScheduleMutation } from "../../State/Api/GetallappointmentsApiSlice";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function ScheduleTime({ show, onClose, doctor }) {
  const [addSchedule] = useAddScheduleMutation();

  const repeatNumbers = Array.from({ length: 99 }, (_, i) => i + 1);
  const repeatUnits = ["day", "week", "month", "year"];

  const clinicUserId = localStorage.getItem("userClinicID");


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userClinicID: clinicUserId || "",
      doctorID: doctor?.doctorId,
      createdBy: "developer",
      primaryRole: doctor?.specialization,
      startDate: "",
      endDate: "",
      isActive: true,
    },
    onSubmit: async (values) => {
      const missing = getMissingFields(formik, weekStart, weekSchedule);
    if (missing.length) {
      toast.warning(`Please fill: ${missing.join(", ")}`);
      return; // Stop submission if missing fields
    }

    // Prepare schedule payload
    if (typeof weekStart === "number") {
      const selectedDay = weekSchedule[weekStart];
      if (selectedDay.startDate && selectedDay.endDate) {
        values.startDate = dayjs(selectedDay.startDate).format("YYYY-MM-DD");
        values.endDate = dayjs(selectedDay.endDate).format("YYYY-MM-DD");
      }
    }

    const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const timings = weekSchedule
      .map((day, index) => {
        if (!day.slots.length) return null;
        return {
          weekdayName: weekDays[index],
          slotDuration: day.duration,
          startTime1: day.slots[0]?.inTime?.isValid?.()
            ? day.slots[0].inTime.format("HH:mm:ss")
            : null,
          endTime1: day.slots[0]?.outTime?.isValid?.()
            ? day.slots[0].outTime.format("HH:mm:ss")
            : null,
          startTime2: day.slots[1]?.inTime?.isValid?.()
            ? day.slots[1].inTime.format("HH:mm:ss")
            : "",
          endTime2: day.slots[1]?.outTime?.isValid?.()
            ? day.slots[1].outTime.format("HH:mm:ss")
            : "",
        };
      })
      .filter(Boolean);

    const payload = {
      ...values,
      timings,
    };

    try {
      const res = await addSchedule(payload).unwrap();
    
      handleClose();

      toast.success("Schedule saved successfully");
    } catch (err) {
      console.error("Failed to add schedule", err);
      toast.error("Failed to save schedule");
    }
    },
  });

    const getMissingFields = (formik, weekStart, weekSchedule) => {
    const missing = [];
    if (!formik.values.doctorID) missing.push("Doctor ID");
    if (typeof weekStart !== "number") missing.push("Day selection");
    if (!weekSchedule[weekStart] || !weekSchedule[weekStart].slots.length)
      missing.push("At least one time slot");
    if (!weekSchedule[weekStart]?.duration) missing.push("Slot Duration");
    if (!weekSchedule[weekStart]?.startDate) missing.push("Start Date");
    if (!weekSchedule[weekStart]?.endDate) missing.push("End Date");
    return missing;
  };

  const { Option } = Select;
  const options = Array.from({ length: 100 }, (_, i) => i + 1);
  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const [weekStart, setWeekStart] = React.useState(null);

  const [daySchedule, setDaySchedule] = useState({
    inTime: dayjs().hour(0).minute(0),
    outTime: dayjs().hour(0).minute(0),
  });

  const [weekSchedule, setWeekSchedule] = useState(
    Array(7).fill({
      slots: [],
      duration: "",
      startDate: new Date(),
      endDate: dayjs(new Date()).add(1, "week").toDate(),
      repeatEvery: 1,
      repeatUnit: "week",
      manualEndDate: false,
    })
  );

  const hasAtLeastOneSlot = weekSchedule.some((day) => day.slots.length > 0);

  const isScheduleDefined = weekSchedule.some((day) => day.slots.length > 0);

  const handleSaveDaySchedule = () => {
    if (typeof weekStart !== "number" || !weekSchedule[weekStart]) {
      console.warn("Invalid weekStart or weekSchedule[weekStart] is undefined");
      return;
    }

    if (!daySchedule.inTime || !daySchedule.outTime) return;

    const newSlot = {
      inTime: daySchedule.inTime,
      outTime: daySchedule.outTime,
    };

    const updatedSchedule = [...weekSchedule];
    const currentDay = updatedSchedule[weekStart];

    const updatedDay = {
      ...currentDay,
      slots: [...currentDay.slots, newSlot].slice(0, 2),
    };

    updatedSchedule[weekStart] = updatedDay;

    const otherDaysEmpty = updatedSchedule.every(
      (day, idx) => idx === weekStart || day.slots.length === 0
    );

    if (otherDaysEmpty) {
      for (let i = 0; i < 7; i++) {
        if (i !== weekStart) {
          updatedSchedule[i] = {
            ...updatedSchedule[i],
            slots: [...updatedDay.slots],
            duration: updatedDay.duration,
            repeatEvery: updatedDay.repeatEvery,
            repeatUnit: updatedDay.repeatUnit,
            startDate: updatedDay.startDate,
            endDate: updatedDay.endDate,
          };
        }
      }
    }

    setWeekSchedule(updatedSchedule);
    setDaySchedule({ inTime: null, outTime: null });
  };

  const handleDeleteSchedule = (indexToDelete) => {
    const updatedSlots = weekSchedule[weekStart].slots.filter(
      (_, i) => i !== indexToDelete
    );
    const updated = [...weekSchedule];
    updated[weekStart] = {
      ...updated[weekStart],
      slots: updatedSlots,
    };
    setWeekSchedule(updated);
  };

  const handleEditSchedule = (indexToEdit) => {
    const slot = weekSchedule[weekStart].slots[indexToEdit];
    setDaySchedule({ inTime: slot.inTime, outTime: slot.outTime });

    const updatedSlots = weekSchedule[weekStart].slots.filter(
      (_, i) => i !== indexToEdit
    );
    const updated = [...weekSchedule];
    updated[weekStart] = {
      ...updated[weekStart],
      slots: updatedSlots,
    };
    setWeekSchedule(updated);
  };

  const handleClose = () => {
    setWeekStart(null);
    setDaySchedule({
      inTime: dayjs().hour(0).minute(0),
      outTime: dayjs().hour(0).minute(0),
    });
    setWeekSchedule(
      Array(7).fill({
        slots: [],
        duration: "",
        startDate: new Date(),
        endDate: dayjs(new Date()).add(1, "week").toDate(),
        repeatEvery: 1,
        repeatUnit: "week",
        manualEndDate: false,
      })
    );
    formik.resetForm();
    onClose(); // invokes the modal close prop
  };

  const dateStyle = `
  
     .rs-radio-group-picker {
         border: none;
         border-radius: 6px;
         color: #343434;
         color: var(--rs-text-primary);
         display: -ms-inline-flexbox;
         baground-color:rgb(31, 135, 233);
         display: inline-flex;
      }

      .rs-radio-group-picker .rs-radio-checked .rs-radio-checker>label {

           color: #fff !important;
    background: #7eb18c;
    width: 2.5rem;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
      }

      .rs-radio rs-radio-inline {
          background: #7eb18c;
    border-radius: 4px;
      }
    
     .rs-radio-group-picker .rs-radio-checker>label {
    border-bottom: none !important;
    width: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
        background-color: #edebe9;
    border-radius: 6px;
}
      rs-radio rs-radio-inline rs-radio-checked>label {
      color: #fff !important;
      }

      .rs-radio-checker>label:hover { 
      color: #7eb18c !important;
        background-color: #edebe9;

      }

.radio-scheduled label {
  background-color: #27d190 !important;
  color: #fff !important;
}

.radio-selected label {
  background-color: #7eb18c !important;
  color: #fff !important;
}



      .MuiTextField-root{
        width: 10rem;
      }

      .MuiIconButton-root > svg{
        width: 1.2rem;
      }

.MuiOutlinedInput-input {
    font: inherit;
    letter-spacing: inherit;
    color: currentColor;
    padding: 4px 0 5px;
    border: 0;
    box-sizing: content-box;
    background: none;
    height: 1.4375em;
    margin: 0;
    -webkit-tap-highlight-color: transparent;
    display: block;
    min-width: 0;
    width: 100%;
    -webkit-animation-name: mui-auto-fill-cancel;
    animation-name: mui-auto-fill-cancel;
    -webkit-animation-duration: 10ms;
    animation-duration: 10ms;
    padding: 10px 10px;
    padding-right: 0;
}

MuiInputLabel-root {
    color: rgba(0, 0, 0, 0.6);
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    font-size: .8rem;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    padding: 0;
    position: relative;
    display: block;
    transform-origin: top left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    position: absolute;
    left: 0;
    top: -4px;
    -webkit-transform: translate(0, 20px) scale(1);
    -moz-transform: translate(0, 20px) scale(1);
    -ms-transform: translate(0, 20px) scale(1);
    transform: translate(0, 20px) scale(1);
    -webkit-transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, -webkit-transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    transition: color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
    z-index: 1;
    pointer-events: none;
    -webkit-transform: translate(14px, 16px) scale(1);
    -moz-transform: translate(14px, 16px) scale(1);
    -ms-transform: translate(14px, 16px) scale(1);
    transform: translate(14px, 16px) scale(1);
    max-width: calc(100% - 24px);
}

.MuiInputLabel-root{
  font-size: 0.8rem;
}

.save-button {
  background-color: #7eb18c; /* Tailwind's emerald-500 for a soft green */
  color: white;
      padding: 5px 13px;
      width: 100%;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}


.custom-time-pill {
    color: #7eb18c;
    padding: 6px 14px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 14px;
    display: inline-block;
    border: 1px solid #7eb18c;
}

.rs-picker-has-value .rs-btn .rs-picker-toggle-value, .rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {
    color: #585858 !important;
 
}


.rs-picker.rs-picker-date .rs-picker-toggle {
  padding: 0;
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  font-size: 0.95rem;
  background-color: transparent;
}

.rs-picker-toggle-textbox {
  padding: 4px 8px !important;
}

.rs-picker-toggle-placeholder {
  color: #999;
}

.rs-input-group.rs-input-group-inside {

  border: none;
  }

.rs-picker-date>.rs-input-group.rs-input-group-inside .rs-input 
{

 font-size: 14px !important;
}

  
  `;

  return (
    <>
      <style>{dateStyle}</style>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        enforceFocus={false}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="example-custom-modal-styling-title"
            style={{ fontSize: "1.2rem" }}
          >
            Doctor Schedule
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>
            <div className="d-flex col-12 mt-3">
              <div className="d-flex flex-column ms-auto col-6  ps-1 pe-3">
                <label className="styled-label" htmlFor="inpt-Lastname">
                  Doctor ID
                </label>
                <InputGroup>
                  <Input
                    placeholder={"Doctor ID"}
                    value={doctor?.doctorId || ""}
                    readOnly
                    disabled
                  />
                </InputGroup>
              </div>
              <div className="d-flex flex-column ms-auto col-6  ps-3 pe-1">
                <label className="styled-label" htmlFor="inpt-Lastname">
                  Doctor Name
                </label>
                <InputGroup>
                  <Input
                    placeholder={"Doctor Name"}
                    value={doctor?.fullName || ""}
                    readOnly
                    disabled
                  />
                </InputGroup>
              </div>
            </div>

            <div className="d-flex col-12 mt-3 mb-3">
              <div className="d-flex flex-column ms-auto col-6  ps-1 pe-3">
                <label className="styled-label" htmlFor="inpt-Lastname">
                  Primary Role
                </label>
                <InputGroup>
                  <Input
                    placeholder={"Doctor Name"}
                    value={doctor?.specialization || ""}
                    readOnly
                    disabled
                  />
                </InputGroup>
              </div>

              <div className="d-flex flex-column ms-auto col-6 ps-3 pe-1">
                <label className="styled-label" htmlFor="slot-duration">
                  Slot Duration (mins)
                </label>
                <SelectPicker
                  id="slot-duration"
                  data={[
                    { label: "5 min", value: 5 },
                    { label: "10 min", value: 10 },
                    { label: "15 min", value: 15 },
                    { label: "20 min", value: 20 },
                    { label: "30 min", value: 30 },
                    { label: "45 min", value: 45 },
                    { label: "60 min", value: 60 },
                  ]}
                  value={weekSchedule[weekStart]?.duration || null}
                  onChange={(value) => {
                    const updated = [...weekSchedule];
                    const currentDay = updated[weekStart];

                    updated[weekStart] = {
                      ...currentDay,
                      duration: value,
                    };

                    for (let i = 0; i < 7; i++) {
                      if (i !== weekStart && !updated[i].duration) {
                        updated[i] = {
                          ...updated[i],
                          duration: value,
                        };
                      }
                    }

                    setWeekSchedule(updated);
                  }}
                  disabled={typeof weekStart !== "number"}
                  until
                  a
                  day
                  is
                  selected
                  searchable
                  cleanable
                  placeholder="Select duration"
                  style={{ width: "100%", zIndex: 9999 }}
                  menuStyle={{ zIndex: 9999 }}
                  placement="autoVerticalEnd"
                  container={() => document.body}
                />
              </div>
            </div>
            <hr />

            {hasAtLeastOneSlot && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "1rem",
                }}
              >
                {/* Start Date */}
                <div
                  className="d-flex flex-column align-items-start mt-3 mb-2"
                  style={{ flex: 1 }}
                >
                  <label
                    htmlFor="start-date"
                    className="mb-1"
                    style={{
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      color: "#333",
                    }}
                  >
                    Start
                  </label>

                  <DatePicker
                    id="start-date"
                    value={weekSchedule[weekStart]?.startDate || new Date()}
                    onChange={(newDate) => {
                      const updated = [...weekSchedule];
                      updated[weekStart].startDate = newDate;
                      // recalculate endDate
                      updated[weekStart].endDate = dayjs(newDate)
                        .add(
                          updated[weekStart].repeatEvery,
                          updated[weekStart].repeatUnit
                        )
                        .toDate();
                      setWeekSchedule(updated);
                    }}
                    placeholder="Select start date"
                    format="dd-MMM-yyyy"
                    oneTap
                    placement="bottomStart"
                    container={() => document.body}
                    style={{
                      width: "100%",
                      zIndex: 1056,
                      border: "none",
                      borderBottom: "1px solid #ccc",
                      paddingBottom: "0px",
                      backgroundColor: "transparent",
                    }}
                    menuStyle={{ zIndex: 1056 }}
                  />
                </div>

                {/* End Date */}
                <div
                  className="d-flex flex-column align-items-start mt-3 mb-2"
                  style={{ flex: 1 }}
                >
                  <label
                    className="mb-1"
                    style={{
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      color: "#333",
                    }}
                  >
                    End
                  </label>
                  <DatePicker
                    value={
                      typeof weekStart === "number"
                        ? weekSchedule[weekStart]?.endDate || null
                        : null
                    }
                    onChange={(newDate) => {
                      if (typeof weekStart === "number") {
                        const updated = [...weekSchedule];
                        updated[weekStart].endDate = newDate;
                        updated[weekStart].manualEndDate = true; // user override
                        setWeekSchedule(updated);
                      }
                    }}
                    placeholder="Select end date"
                    format="dd-MMM-yyyy"
                    oneTap
                    placement="bottomStart"
                    container={() => document.body}
                    style={{
                      width: "100%",
                      zIndex: 1056,
                      border: "none",
                      borderBottom: "1px solid #ccc",
                      paddingBottom: "0px",
                      backgroundColor: "transparent",
                    }}
                    menuStyle={{ zIndex: 1056 }}
                  />
                </div>
              </div>
            )}

            {hasAtLeastOneSlot && (
              <div style={{ marginTop: "1rem" }}>
                <div className="d-flex justify-content-center align-items-center gap-3 mb-3">
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4%",
                      width: "28%",
                    }}
                  >
                    <RiRepeat2Line color="gray" /> Repeat every
                  </span>

                  <Listbox
                    value={
                      typeof weekStart === "number"
                        ? weekSchedule[weekStart]?.repeatEvery || 1
                        : 1
                    }
                    onChange={(value) => {
                      if (typeof weekStart === "number") {
                        const updated = [...weekSchedule];
                        // updated[weekStart].repeatEvery = value;
                        // if (!updated[weekStart].manualEndDate) {
                        //   updated[weekStart].endDate = dayjs(
                        //     updated[weekStart].startDate
                        //   )
                        //     .add(value, updated[weekStart].repeatUnit)
                        //     .toDate();
                        // }

                        updated[weekStart].repeatEvery = value;
                        updated[weekStart].manualEndDate = false; // reset manual flag
                        updated[weekStart].endDate = dayjs(
                          updated[weekStart].startDate
                        )
                          .add(value, updated[weekStart].repeatUnit)
                          .toDate();
                        setWeekSchedule(updated);
                      }
                    }}
                  >
                    <div className="position-relative">
                      <ListboxButton
                        className="btn-outline-secondary"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "none",
                        }}
                      >
                        {typeof weekStart === "number"
                          ? weekSchedule[weekStart]?.repeatEvery || 1
                          : 1}
                        <FaChevronDown className="ms-1" />
                      </ListboxButton>
                      <ListboxOptions
                        className="dropdown-menu show"
                        style={{
                          height: "14rem",
                          width: "4rem",
                          overflowY: "scroll",
                          fontSize: "14px",
                          minWidth: "4rem",
                        }}
                      >
                        {repeatNumbers.map((num) => (
                          <ListboxOption
                            key={num}
                            value={num}
                            className="dropdown-item"
                          >
                            {num}
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>

                  <Listbox
                    value={
                      typeof weekStart === "number"
                        ? weekSchedule[weekStart]?.repeatUnit || "week"
                        : "week"
                    }
                    onChange={(unit) => {
                      if (typeof weekStart === "number") {
                        const updated = [...weekSchedule];
                        // updated[weekStart].repeatUnit = unit;
                        // if (!updated[weekStart].manualEndDate) {
                        //   updated[weekStart].endDate = dayjs(
                        //     updated[weekStart].startDate
                        //   )
                        //     .add(updated[weekStart].repeatEvery, unit)
                        //     .toDate();
                        // }

                        updated[weekStart].repeatUnit = unit;
                        updated[weekStart].manualEndDate = false; // reset manual flag
                        updated[weekStart].endDate = dayjs(
                          updated[weekStart].startDate
                        )
                          .add(updated[weekStart].repeatEvery, unit)
                          .toDate();

                        setWeekSchedule(updated);
                      }
                    }}
                  >
                    <div className="position-relative">
                      <ListboxButton
                        className="btn-outline-secondary"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          border: "none",
                        }}
                      >
                        {typeof weekStart === "number"
                          ? weekSchedule[weekStart]?.repeatUnit || "week"
                          : "week"}
                        <FaChevronDown className="ms-1" />
                      </ListboxButton>
                      <ListboxOptions className="dropdown-menu show">
                        {repeatUnits.map((unit) => (
                          <ListboxOption
                            key={unit}
                            value={unit}
                            className="dropdown-item"
                          >
                            {unit}
                          </ListboxOption>
                        ))}
                      </ListboxOptions>
                    </div>
                  </Listbox>
                </div>
              </div>
            )}

            <div className="mt-3 d-flex justify-content-center align-items-center">
              <RadioGroup
                inline
                appearance="picker"
                value={weekStart}
                onChange={(value) => {
                  setWeekStart(value);
                }}
              >
                {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                  (day, index) => {
                    let radioClass = "";
                    if (weekSchedule[index]?.slots?.length > 0) {
                      radioClass = "radio-scheduled";
                    }
                    if (weekStart === index) {
                      radioClass = "radio-selected";
                    }
                    return (
                      <Radio key={index} value={index} className={radioClass}>
                        {day}
                      </Radio>
                    );
                  }
                )}
              </RadioGroup>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
              <div style={{ margin: "1rem auto" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    onChange={(value) =>
                      setDaySchedule({ ...daySchedule, inTime: value })
                    }
                    value={daySchedule.inTime}
                    label="In time"
                  />
                </LocalizationProvider>
              </div>
              -
              <div style={{ margin: "1rem auto" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    onChange={(value) =>
                      setDaySchedule({ ...daySchedule, outTime: value })
                    }
                    value={daySchedule.outTime}
                    label="Out time"
                  />
                </LocalizationProvider>
              </div>
              <div style={{ margin: "1rem auto" }}>
                <button
                  onClick={handleSaveDaySchedule}
                  className="save-button"
                  disabled={weekSchedule[weekStart]?.slots?.length >= 2}
                >
                  Add
                </button>
              </div>
            </div>

            <Divider variant="middle">
              <span style={{ fontSize: "1.2rem", color: "#7eb18c" }}>
                {weekDays[weekStart]}
              </span>
            </Divider>

            <div className="d-flex flex-wrap">
              {weekSchedule[weekStart]?.slots?.map((schedule, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between m-2 p-2 custom-time-pill"
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "1rem",
                    minWidth: "200px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleEditSchedule(index)}
                >
                  <div className="mx-2">
                    {schedule.inTime.format("hh:mm A")} -{" "}
                    {schedule.outTime.format("hh:mm A")}
                  </div>
                  <div className="d-flex">
                    {/* <button
                      className="btn btn-sm btn-outline-primary mx-1"
                      onClick={() => handleEditSchedule(index)}
                    >
                      Edit
                    </button> */}
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteSchedule(index);
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}

              <button
                className="save-button"
                style={{
                  marginTop: "2rem",
                  padding: "8px 13px",
                  backgroundColor: "#253b50",
                }}
                onClick={formik.handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
        <Button onClick={() => setScheduleShow(false)}>Close</Button>
      </Modal.Footer> */}
      </Modal>
    </>
  );
}

const RadioLabel = ({ children }) => (
  <label style={{ padding: 7 }}>{children}</label>
);

export default ScheduleTime;
